/** Квадратная кнопка быстрого фильтра очереди квот (server-side фильтры
 *  «Мои», «Просрочено», «Нужна инфо», «Доработка»). Вынесена из
 *  ProcurementQueuePage.tsx — рефакторинг 21.05.2026, стиль идентичен. */
export function QueueFilterBtn({
  label,
  active,
  onChange,
}: {
  label: string
  active: boolean
  onChange: () => void
}) {
  return (
    <button
      onClick={onChange}
      className={`px-3 py-1.5 rounded-lg text-xs border transition-colors whitespace-nowrap ${
        active
          ? 'bg-brand-600 text-white border-brand-600'
          : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'
      }`}
    >
      {label}
    </button>
  )
}
